module.exports = __webpack_public_path__ + "static/img/4103_phase_function_Paper_Points.fedd607.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4103_phase_function_Paper_Points.png
// module id = r1rn
// module chunks = 0